import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { PartyPopper, X } from 'lucide-react';
import type { Conquista } from '../../domain/entities/PerfilJukebox';
import type { RankFa } from '../../domain/usecases/calcularRankFa';
import { CONQUISTA_ICON_MAP } from './conquistaIcons';

const DURACAO_MS = 4_000;

interface Props {
  novoNivel:       RankFa | null;
  novasConquistas: Conquista[];
  onDismiss:       () => void;
}

export function ConquistaDesbloqueada({ novoNivel, novasConquistas, onDismiss }: Props) {
  useEffect(() => {
    const t = setTimeout(onDismiss, DURACAO_MS);
    return () => clearTimeout(t);
  }, [onDismiss]);

  const titulo = novoNivel
    ? `Novo nível: ${novoNivel.nome}`
    : novasConquistas.length === 1
      ? 'Conquista desbloqueada'
      : 'Conquistas desbloqueadas';

  return (
    <motion.div
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -24, opacity: 0 }}
      transition={{ type: 'spring', damping: 22, stiffness: 300 }}
      className="fixed top-12 left-0 right-0 z-40 px-4 pointer-events-none"
    >
      <div className="max-w-sm mx-auto bg-jukebox-sheet rounded-2xl border border-orange-500/20 shadow-lg pointer-events-auto">
        <div className="flex items-center gap-3 px-3 py-2.5">
          <div className="shrink-0 w-9 h-9 rounded-xl bg-gradient-to-br from-orange-500 to-rose-500 flex items-center justify-center">
            <PartyPopper size={16} className="text-white" />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold text-white truncate">{titulo}</p>
            {novasConquistas.length > 0 && (
              <div className="flex items-center gap-1.5 mt-1">
                {novasConquistas.map(c => {
                  const Icon = CONQUISTA_ICON_MAP[c.icone] || CONQUISTA_ICON_MAP.Star;
                  return (
                    <div
                      key={c.id}
                      title={c.nome}
                      className="w-6 h-6 rounded-lg bg-orange-500/[0.1] border border-orange-500/30 flex items-center justify-center"
                    >
                      <Icon size={12} className="text-orange-400" />
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          <button
            onClick={onDismiss}
            aria-label="Fechar"
            className="shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-white/40 active:bg-white/[0.07]"
          >
            <X size={14} />
          </button>
        </div>
      </div>
    </motion.div>
  );
}
